
export function compare (s1, s2) {
  if (s1 === s2) return 0
  else if (s1 > s2) return 1
  else return -1
}

export function isValid (data) {
  return data !== 'undefined' && data !== 'null' && data
}
